require 'angular'

angular.module('workflow.app')
  .directive('customSourceModalButton', require './CustomSourceModalButton')
  .controller('CustomSourceModalController', require './CustomSourceModalController')
